import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit, OnDestroy } from '@angular/core';
import { MenuService, PlatformService } from '@app/services';
import { merge, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-sticky-action-bar',
  templateUrl: './sticky-action-bar.component.html',
  styleUrls: ['./sticky-action-bar.component.scss']
})
export class StickyActionBarComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() title: string;
  @Input() saving: boolean;
  @Input() disabledSave: boolean;

  // I think this option should be renamed and opposite : "saveBtn" only when needed (in admin mostly) + now we have more "noSave" case ...
  @Input() noSave: boolean;
  @Input() back: any;

  @Output() save = new EventEmitter();

  marginLeft: number;

  loaded = false;

  onDestroy$ = new Subject();

  constructor(
    public menuService: MenuService,
    public platformService: PlatformService
  ) { }

  ngOnInit() {
    merge(
      this.menuService.sidenav.openedStart,
      this.menuService.sidenav.closedStart
    ).pipe(
      takeUntil(this.onDestroy$),
    ).subscribe(x => this.setMargin());
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.loaded = true;
      this.setMargin();
    }, 1000);
  }

  setMargin() {
    this.marginLeft = this.menuService.sidenav.opened && this.menuService.sidenav.mode !== 'over' ? 270 : 0;
  }

  onBack() {
    if (!this.back) {
      history.back();
    } else if (this.back instanceof EventEmitter) {
      this.back.emit();
    }
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
